/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LeverageWithdrawOptions,
  LeverageWithdrawStatus201,
  LeverageWithdrawStatus400,
  LeverageWithdrawStatus401,
  LeverageWithdrawStatus500,
} from '../types/LeverageWithdraw'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { leverageWithdraw } from '../clients/leverageWithdraw'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const leverageWithdrawMutationKey = () => [{ url: '/v1/leverage/withdraw' }] as const

export function leverageWithdrawMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = leverageWithdrawMutationKey()
  return mutationOptions<
    LeverageWithdrawStatus201,
    ResponseErrorConfig<
      LeverageWithdrawStatus400 | LeverageWithdrawStatus401 | LeverageWithdrawStatus500
    >,
    LeverageWithdrawOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return leverageWithdraw({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Withdraw leverage for a specific asset
 * {@link /v1/leverage/withdraw}
 */
export function useLeverageWithdraw<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LeverageWithdrawStatus201,
      ResponseErrorConfig<
        LeverageWithdrawStatus400 | LeverageWithdrawStatus401 | LeverageWithdrawStatus500
      >,
      LeverageWithdrawOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? leverageWithdrawMutationKey()

  const baseOptions = leverageWithdrawMutationOptions(config) as UseMutationOptions<
    LeverageWithdrawStatus201,
    ResponseErrorConfig<
      LeverageWithdrawStatus400 | LeverageWithdrawStatus401 | LeverageWithdrawStatus500
    >,
    LeverageWithdrawOptions,
    TContext
  >

  return useMutation<
    LeverageWithdrawStatus201,
    ResponseErrorConfig<
      LeverageWithdrawStatus400 | LeverageWithdrawStatus401 | LeverageWithdrawStatus500
    >,
    LeverageWithdrawOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LeverageWithdrawStatus201,
    ResponseErrorConfig<
      LeverageWithdrawStatus400 | LeverageWithdrawStatus401 | LeverageWithdrawStatus500
    >,
    LeverageWithdrawOptions,
    TContext
  >
}
